import { useAppSelector } from 'hooks/redux';
import type { List } from 'immutable';
import React from 'react';

import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';

import type { TaxFormType } from 'app-components/flux/categories/categoriesTypes';
import { taxFormsSelectors } from 'app-components/flux/tax-forms';

import { useMultiFields } from 'app-components/flux/categories/categoryFormHooks';
import useStyles from './styles';

type Props = {
  type: string;
};

const TaxFormBusiness = ({ type }: Props) => {
  const { classes } = useStyles();

  const { value, error, helperText, onValueChange } = useMultiFields('businessTaxInfo', type);

  const taxForms: List<TaxFormType> = useAppSelector(taxFormsSelectors.getTaxForms);

  return (
    <TextField
      variant='filled'
      label='Tax Form'
      name='taxForm'
      value={value.taxForm || ''}
      className={classes.dropDown}
      select
      onChange={(e) => onValueChange(e.target)}
      id='tax-form-dropdown'
      error={(!value.taxForm || value.taxForm === '') && error}
      helperText={helperText}
      InputLabelProps={{
        classes: {
          root: classes.inputLabel,
        },
      }}
    >
      {taxForms.map((form) => (
        <MenuItem value={form.id} key={form.id}>
          <Tooltip title={form.description} placement='right'>
            <span>{form.name}</span>
          </Tooltip>
        </MenuItem>
      ))}
    </TextField>
  );
};

export default TaxFormBusiness;
